import { arcadeApiClient } from '../apiClients'
import useSWR from 'swr'
import { SelectableTeam } from 'types'

const teamsFetcher = async (endpoint): Promise<{ teams: SelectableTeam[] }> => {
  return arcadeApiClient.get(endpoint).then(res => res.data)
}

/* 
  This hook returns the teams that the current user manages. This should be used in places where a user's access 
  to a team allows them to perform some action relating to it. For example if we have a section where you can choose 
  to add a player to a team we should use this one 
*/
export const useSelectableTeams = () => {
  const { data, isValidating, error } = useSWR(
    '/multi_platform/select/teams',
    teamsFetcher,
  )

  return {
    teams: data?.teams as SelectableTeam[],
    loading: isValidating,
    error,
  }
}
